import React, { Suspense } from "react";
import MatxLoading from "./MatxLoading";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<MatxLoading />}>
      <Component {...props} />
    </Suspense>
  );
};
export default Loadable;
